import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { NoSmoking as NoSmokingIcon } from '@/ui/icons/no-smoking';

export default function NoSmoking() {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <View style={{ gap: 8 }}>
        <Text type="title1">No Smoking Policy</Text>

        <Text type="bodyRegular" style={{ color: theme.colors.text.secondary }}>
          Smoking or vaping of any kind is strictly prohibited in the vehicle.
          Violating this policy will result in the forfeiture of your deposit.
          This includes cigarettes, marijuana, vapes, and any other substances.
        </Text>
      </View>

      <View>
        <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
          <Icon
            type="dressed"
            icon={<NoSmokingIcon />}
            width={25}
            height={25}
          />

          <Text type="bodyBold">No smoking</Text>
        </View>
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    minWidth: '100%',
    gap: 24,
    backgroundColor: theme.colors.background_1,
    justifyContent: 'space-between',
  },
}));
